import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative h-full flex flex-col" }
const _hoisted_2 = { class: "flex justify-between items-center px-3 py-2 text-xs text-[#0e0e0e] lg:hidden" }
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "flex items-center gap-1" }
const _hoisted_6 = { class: "flex-1 overflow-y-auto" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { class: "flex-1 flex items-center" }
const _hoisted_9 = { class: "ml-2 font-bold" }
const _hoisted_10 = { class: "flex-1 font-bold" }
const _hoisted_11 = { class: "flex flex-col py-3 px-3 text-[13px] text-[#0e0e0e] border-t border-gray-200 bg-white space-y-3" }
const _hoisted_12 = { class: "grid grid-cols-2 gap-2 lg:hidden" }
const _hoisted_13 = { class: "flex justify-start" }
const _hoisted_14 = { class: "flex justify-end" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_17 = { class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary transition-all duration-200 group-hover:bg-primary group-hover:text-white" }
const _hoisted_18 = { class: "min-w-0" }
const _hoisted_19 = { class: "text-sm font-semibold text-[#0e0e0e] leading-tight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LanguageButton = _resolveComponent("LanguageButton")!
  const _component_DocumentButton = _resolveComponent("DocumentButton")!

  return (_openBlock(), _createElementBlock("div", {
    id: "slide-out",
    class: _normalizeClass([
      'fixed top-15.5 lg:top-21 right-0 lg:left-0 lg:right-auto',
      'h-[calc(100vh-62px)] lg:h-[calc(100vh-84px)]',
      'w-67.5 lg:w-65 bg-secondary-background shadow-lg z-1001 flex flex-col',
      'transform-gpu transition-transform duration-300 ease-out',
      _ctx.isActive ? 'translate-x-0' : 'translate-x-full',
      'lg:translate-x-0'
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "far fa-user-circle text-base" }, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayUsername), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-briefcase text-base" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.displayRole), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menu, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: idx,
              class: _normalizeClass([
              'group text-sm border-b border-slate-200 last:border-b-0 py-0.5',
              _ctx.isMenuActive(menu) ? 'bg-primary/10' : 'hover:bg-primary/5'
            ])
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(menu.route ? 'router-link' : 'a'), {
                to: menu.route,
                class: _normalizeClass([
                'w-full flex items-center justify-between px-3 py-2 cursor-pointer transition-all border-l-4',
                _ctx.isMenuActive(menu) ? 'border-primary' : 'border-transparent'
              ]),
                onClick: ($event: any) => (_ctx.onMainClick(menu, idx))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`text-primary sv-slim-icon ${menu.icon}`)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(`${idx + 1}. ${_ctx.translateLabel(menu.displayName)}`), 1)
                  ]),
                  (menu.child && menu.child.length)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(["fas fa-angle-down ml-2 transition-transform duration-150", _ctx.currentChild === idx ? 'rotate-180' : ''])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "class", "onClick"])),
              (menu.child && menu.child.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([_ctx.currentChild === idx ? 'block' : 'hidden', "pl-6 pr-2 py-1"])
                  }, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.child.filter(item => typeof item.parentName === 'string'), (child, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: "mb-1"
                        }, [
                          _createVNode(_component_router_link, {
                            to: child.route,
                            class: _normalizeClass([
                      'flex items-center text-xs py-1 pr-3 pl-7 transition-all',
                      _ctx.$route.path === child.route
                        ? 'text-primary font-semibold bg-primary/5'
                        : 'text-gray-700 hover:bg-primary/5'
                    ]),
                            onClick: _ctx.onChildClick
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(`${idx + 1}.${i + 1} ${_ctx.translateLabel(child.displayName)}`), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class", "onClick"])
                        ]))
                      }), 128))
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_LanguageButton)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_DocumentButton)
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "group w-full flex items-center justify-between rounded-xl border border-slate-200 bg-gradient-to-r from-white to-slate-50 px-4 py-3 text-left shadow-sm transition-all duration-200 hover:shadow-md hover:border-primary/40 hover:-translate-y-[1px] active:translate-y-0 disabled:opacity-60 disabled:cursor-not-allowed",
          disabled: _ctx.isSwitchingLegacy,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLegacyWeb()))
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.isSwitchingLegacy ? 'fas fa-spinner fa-spin text-sm' : 'fas fa-arrow-left text-sm')
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('util.legacy')), 1)
            ])
          ])
        ], 8, _hoisted_15),
        _createElementVNode("button", {
          type: "button",
          class: "w-full flex items-center justify-center gap-2 py-2 rounded-md text-[13px] font-semibold text-red-600 border border-red-300 hover:bg-red-50 active:bg-red-100 transition lg:hidden",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onLogout()))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-sign-out-alt text-sm" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.signout')), 1)
        ])
      ])
    ])
  ], 2))
}